
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.297 12l-8.545 8.448a.902.902 0 000 1.286.927.927 0 001.3 0l9.196-9.092a.904.904 0 000-1.285l-9.195-9.09A.922.922 0 007.403 2a.922.922 0 00-.65.266.902.902 0 000 1.286L15.296 12z","fill":"currentColor"}})])
          )
        }
      }
    